import {Injectable} from '@angular/core';
import {environment} from '~env/environment';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {

  prefixo = '[Logger]';
  hidden?: boolean;

  constructor() {
    this.hidden = environment.experimentalFeatures?.hiddenLogger;
  }

  log(mensagem: string, objeto?: unknown): void {
    if (!this.hidden) {
      console.log(`${this.prefixo} ${mensagem}`, objeto || '');
    }
  }

  debug(mensagem: string, objeto?: unknown): void {
    if (!environment.production && !this.hidden) {
      console.log(`${this.prefixo} ${mensagem}`, objeto || '');
    }
  }

  error(mensagem: string, objeto?: unknown): void {
    if (!this.hidden) {
      console.error(`${this.prefixo} ${mensagem}`, objeto || '');
    }
  }

  warn(mensagem: string, objeto?: unknown): void {
    if (!this.hidden) {
      console.warn(`${this.prefixo} ${mensagem}`, objeto || '');
    }
  }
}
